import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Clock, Loader2, ShieldCheck, ShieldOff } from "lucide-react";

/* Admin review controls for a bank: portal approval. */
export default function BankReviewCell({ bank, onChanged }) {
  const [busy, setBusy] = useState(false);
  const review = async () => {
    setBusy(true);
    try {
      const r = await api.patch(`/banks/${bank.id}/review`, { is_approved: !bank.is_approved });
      onChanged(r.data);
      toast.success(bank.is_approved ? "Approval revoked" : `${bank.name} approved`);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center justify-between gap-2 min-w-[210px]" data-testid={`bank-review-${bank.id}`}>
      {bank.is_approved
        ? <span className="inline-flex items-center gap-1 text-xs text-emerald-700" data-testid={`bank-approval-state-${bank.id}`}><ShieldCheck className="h-3.5 w-3.5" /> Approved</span>
        : <span className="inline-flex items-center gap-1 text-xs text-amber-700 font-semibold" data-testid={`bank-approval-state-${bank.id}`}><Clock className="h-3.5 w-3.5" /> Pending approval</span>}
      <Button size="sm" variant={bank.is_approved ? "ghost" : "default"} disabled={busy} onClick={review}
        className={bank.is_approved ? "h-7 text-xs text-red-600 hover:text-red-700" : "h-7 text-xs bg-emerald-600 hover:bg-emerald-700 text-white"} data-testid={`bank-approve-${bank.id}`}>
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : bank.is_approved ? <><ShieldOff className="h-3 w-3 mr-1" /> Revoke</> : "Approve"}
      </Button>
    </div>
  );
}
